import axios from "axios";
import React, { useEffect, useState } from "react";
import gold from "../../../images/goldMedal.svg";
import silver from "../../../images/silverMedal.svg";
import bronze from "../../../images/bronzeMedal.svg";
import downloadIcon from "../../../images/searchBarDownload.svg";
import NoDataIcon from "../../../images/NoDataIcon";
import ImageLoading from "../../../components/ImageLoading";
import IconDownloadButton from "../../../components/IconDownloadButton";

const NewTableUsers = ({ checkPledged }) => {
  const [loading, setLoading] = useState(false);
  const [topPledgedMutualFunds, setTopPledgedMutualFunds] = useState([]);
  const [fundDownload, setFundDownload] = useState(false);

  const [hasPledgedFund, setHasPledgedFund] = useState(true);

  const getTopPledgedMutualFunds = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const options = {
        url: `${process.env.REACT_APP_URL}/lender/v1/dashboards/top_pledged_users_mutual_funds`,
        method: "GET",
        headers: { Authorization: token },
      };
      const res = await axios(options);
      //   console.log(res.data.top_pledged_mutual_funds);
      if (!res.data.top_pledged_users_mutual_funds.length)
        setHasPledgedFund(false);
      else {
        setHasPledgedFund(true);
      }
      setTopPledgedMutualFunds(res.data.top_pledged_users_mutual_funds);
      setLoading(false);
    } catch (error) {}
  };

  useEffect(() => {
    getTopPledgedMutualFunds();
  }, []);
  function formatToIndianRupees(num) {
    // Convert the number to a string
    return num.toLocaleString("en-IN", {
      maximumFractionDigits: 2,
      style: "currency",
      currency: "INR",
    });
  }

  checkPledged(hasPledgedFund);
  function truncateString(str) {
    if (str === null) return "---";
    const maxLength = 25;
    if (str?.length <= maxLength) {
      return str;
    } else {
      return str?.substring(0, maxLength) + "...";
    }
  }
  const handleDownloadFile = (url) => {
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", ""); // 'download' attribute triggers download
    document.body.appendChild(link);
    link.click();
    link.remove();
  };
  const handleExcelDownload = async () => {
    // setDownloadLoading(true);
    const token = localStorage.getItem("token");
    try {
      const options = {
        url: `${process.env.REACT_APP_URL}/lender/v1/dashboards/pledged_mutual_funds_excel?download=true&pledged_mutual_fund_type=users`,
        method: "GET",
        headers: { Authorization: token },
      };
      const res = await axios(options);
      // console.log(res);

      if (res.data.download_url.status) {
        handleDownloadFile(res.data.download_url.data);
        // setDownloadLoading(false);
      }
    } catch (error) {
      // setDownloadLoading(false);
      console.log(error);
    } finally {
    }
  };
  return (
    <>
      {loading ? (
        <div className="flex w-full h-[30vh] justify-center items-center ">
          <ImageLoading />
        </div>
      ) : (
        <>
          {" "}
          <div className="bg-white h-full overflow-y-scroll rounded-lg">
            <div className="text-[16px] font-semibold  px-4 mt-[17px] mb-[14px] flex justify-between items-center">
              <p>Top 5 Active Pledged Users</p>
              <button onClick={() => handleExcelDownload()}>
                {" "}
                <IconDownloadButton
                  bg="bg-[#00394d]"
                  iconColor={"text-white"}
                />
              </button>
            </div>

            <table className="w-full">
              <thead className=" bg-[#e6ebed] text-sm">
                <th className=" h-[36px] w-[12%] ">No.</th>
                <th className=" w-[65%] text-left pl-[90px]">User Name</th>
                <th>Pledged value</th>
              </thead>
              <tbody className=" text-center text-xs font-medium">
                {topPledgedMutualFunds?.map((item, index) => {
                  if (item.name === null && item.total_pledged_amount === 0.0)
                    return <></>;
                  return (
                    <tr
                      key={index}
                      className={` ${
                        index % 2 === 0 ? "bg-[#ffffff]" : "bg-[#f8f8f8]"
                      }`}
                    >
                      <td className=" h-[36px]">{index + 1}</td>
                      <td
                        className="text-left pl-[90px]"
                        title={item?.name?.length > 25 ? item?.name : ""}
                      >
                        {truncateString(item?.name)}
                      </td>
                      <td>
                        {formatToIndianRupees(item?.total_pledged_amount)}
                      </td>
                    </tr>
                  );
                })}
                <td></td>
              </tbody>
            </table>
          </div>
        </>
      )}
    </>
  );
};

export default NewTableUsers;
